module.exports = __webpack_public_path__ + "static/img/13.673a0d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/13.png
// module id = neyq
// module chunks = 0